"use client";
import React from "react";
import styled from "styled-components";
import i18n from "@/i18n";

const FeatureSection = styled.section`
  background-color: white;
  display: flex;
  justify-content: center;  
  align-items: center;
  width: 100%;
  padding: 180px 0 0 0;
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 800px;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;

  .main-messasge {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;

    >img {
      width: 48px;
      height: 48px;
    }

    >span {
      color: rgba(81, 81, 81, 1);
      font-size: 34px;
      font-weight: 800;
      line-height: 46px;
      letter-spacing: -0.68px;
      text-align: center;
      margin: 0 -20px;
    }
  }

  span {
    &.highlight {
      font-weight: 600;
      font-size: 20px;
      color: rgba(0, 189, 203, 1);
    }
  }
`;

const VideoWrapper = styled.div`
  display: flex
  align-items: center;
  justify-content: center;
  width: 80%;
  overflow: hidden;
  object-fit: cover;
  margin: 100px auto 60px auto;

  >video {
    width: 800px;
    height: 702px;
    border-radius: 30px;
  }
`;

export default function FeatureDescription() {
  return (
    <FeatureSection>
      <ContentWrapper>
        <Title>
          <div className="main-messasge">
            <img src="https://front.videomonster.com/images-7cuytg20/web/v2/landing2025/frame-left.svg" alt="left" />
            <span>From Generative to Completion</span>
            <img src="https://front.videomonster.com/images-7cuytg20/web/v2/landing2025/frame-right.svg" alt="right" />
          </div>
          <span className="highlight">
            {i18n.t("web.pc.landing.2025.feature.description")}
          </span>
        </Title>
        <VideoWrapper>
          <video src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2025/2_banner_pc.mp4" autoPlay muted loop playsInline />
        </VideoWrapper>
      </ContentWrapper>
    </FeatureSection>
  );
}
